import { InquiryStatus } from 'dashboard/models/inquiry';
import { StickerProps } from 'design-system/components/Sticker';

export const INQUIRY_STATUS_LEVEL_MAP: Record<InquiryStatus, StickerProps['variant']> = {
  [InquiryStatus.Created]: 'basic',
  [InquiryStatus.Pending]: 'caution',
  [InquiryStatus.Completed]: 'success',
  [InquiryStatus.Failed]: 'danger',
  [InquiryStatus.NeedsReview]: 'caution',
  [InquiryStatus.Approved]: 'success',
  [InquiryStatus.Declined]: 'danger',
  [InquiryStatus.Expired]: 'caution',
};

export const INQUIRY_STATUS_LABEL_MAP: Record<InquiryStatus, string> = {
  [InquiryStatus.Created]: 'Created',
  [InquiryStatus.Pending]: 'Pending',
  [InquiryStatus.Completed]: 'Completed',
  [InquiryStatus.Failed]: 'Failed',
  [InquiryStatus.NeedsReview]: 'Needs Review',
  [InquiryStatus.Approved]: 'Approved',
  [InquiryStatus.Declined]: 'Declined',
  [InquiryStatus.Expired]: 'Expired',
};
